import { Enums } from "../helper/enums";
import { apiConstants } from "../constant/constants";
import { ticketEntity } from "../model/entity/ticket-entity";
import ticketApiService from "../services/ticket-api-service";
import commonService from "../services/common-api-service";
import type { entityProcessDictionary } from "./signalr-process-config";
import { EntityEnumConfig } from "./entity-enums-config";
import { formEntity } from "../model/entity/form-entity";
import formService from "../services/form-api-service";
import { invoiceEntity } from "../model/entity/invoice-entity";
import billingService from "../services/billing-service";
import contactService from "../services/contact-service";
import { contactEntity } from "../model/entity/contact-entity";
import { clientLocationEntity } from "../model/entity/client-location-entity";
import ClientService from "../services/client-api-service";

const ticketDetailApiPathForHasAccess =
  "/" +
  apiConstants.apiController.ticket +
  "/" +
  apiConstants.apiAction.ticketUrls.ticketdetailbyid;

//#region SignalR Entity Enums
const SignalREnumConfig: entityProcessDictionary = {
  [Enums.SignalRMessageType[
    Enums.SignalRMessageType.TicketPrivateCommentAdded
  ]]: {
    promise: null,
    entity: ticketEntity,
    methodName: "ticketPrivateCommentAdded",
    hasAccess: () => {
      return true;
    },
  },
  [Enums.SignalRMessageType[Enums.SignalRMessageType.TicketEntitySync]]: {
    promise: ticketApiService.getTicketDetailByIdForSignalR,
    entity: ticketEntity,
    methodName: "ticketEntitySync",
    hasAccess: () => {
      return commonService.HasAccess(ticketDetailApiPathForHasAccess);
    },
  },
  [Enums.SignalRMessageType[Enums.SignalRMessageType.ItemRecovered]]: {
    promise: ticketApiService.getTicketDetailByIdForSignalR,
    entity: ticketEntity,
    methodName: "itemRecovered",
    hasAccess: () => {
      return commonService.HasAccess(ticketDetailApiPathForHasAccess);
    },
  },
  [Enums.SignalRMessageType[Enums.SignalRMessageType.FormEntitySync]]: {
    promise: formService.getFormById,
    entity: formEntity,
    methodName: "formEntitySync",
    hasAccess: () => {
      return true;
    },
  },
  [Enums.SignalRMessageType[Enums.SignalRMessageType.InvoiceEntitySync]]: {
    promise: billingService.getInvoiceListById,
    entity: invoiceEntity,
    methodName: "invoiceEntitySync",
    hasAccess: () => {
      return true;
    },
  },
  [Enums.EntitySyncManager[Enums.EntitySyncManager.CheckInvoiceTick]]: {
    promise: billingService.getInvoicesByTick,
    entity: invoiceEntity,
    methodName: "checkInvoiceTick",
    hasAccess: () => {
      return true;
    },
  },
  [Enums.SignalRMessageType[Enums.SignalRMessageType.ContactEntitySync]]: {
    promise: contactService.getPratialContactById,
    entity: contactEntity,
    methodName: "contactEntitySync",
    hasAccess: () => {
      return true;
    },
  },
  [Enums.SignalRMessageType[Enums.SignalRMessageType.ClientLocationEntitySync]]:
    {
      promise: ClientService.getClientLocations,
      entity: clientLocationEntity,
      methodName: "clientLocationEntitySync",
      hasAccess: () => {
        return true;
      },
    },
};

export const EnumConfig = {
  ...SignalREnumConfig,
  ...EntityEnumConfig,
};
